import clsx from 'clsx'
import type { ButtonHTMLAttributes } from 'react'
import React from 'react'

import Spinner from '../Spinner'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?:
        | 'default'
        | 'primary'
        | 'primary-gradient'
        | 'secondary'
        | 'danger'
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    square?: boolean
    loading?: boolean
}

const Button: React.FC<ButtonProps> = ({
    variant = 'primary-gradient',
    size = 'lg',
    square = false,
    className,
    loading = false,
    ...props
}) => {
    const buttonClass = clsx(
        'btn fullRadius',
        `btn--${variant}`,
        `btn--${size}`,
        {
            'btn--square': square,
            'btn--min-w-100': loading && !square,
            disabled: props.disabled || loading,
        },
        className,
    )

    return (
        <button
            className={buttonClass}
            {...props}
        >
            {!loading ? props.children : <Spinner size="xs" />}
        </button>
    )
}

export default Button
